"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Task = void 0;
var React = require("react");
var _ = require("lodash");
var date_fns_1 = require("date-fns");
var Icon_1 = require("../../Icon");
var Task_style_1 = require("./Task.style");
var Popup_1 = require("../Popup/Popup");
var Button_1 = require("../../Button");
var ButtonClean_1 = require("../../Button/ButtonClean");
var Checkbox_1 = require("../../Checkbox");
var Loader_1 = require("../../Loader");
exports.Task = function (props) {
    var id = props.id, buttonPath = props.buttonPath, saving = props.saving, coins = props.coins, icon = props.icon, title = props.title, description = props.description, pushToHistory = props.pushToHistory, isDesktop = props.isDesktop, maxDays = props.maxDays, doneDays = props.doneDays, isPopup = props.isPopup, buttonText = props.buttonText, onDefaultClick = props.onDefaultClick, onArrowClick = props.onArrowClick, children = props.children, completed = props.completed, pledgeTimePeriod = props.pledgeTimePeriod, pledgeLastClicked = props.pledgeLastClicked, loading = props.loading, isBonus = props.isBonus, ctaOpenPopup = props.ctaOpenPopup, closeCtaPopup = props.closeCtaPopup, closeButton = props.closeButton, internalType = props.internalType, textKey = props.textKey, buttonBackground = props.buttonBackground, buttonActionBackground = props.buttonActionBackground, completeDescription = props.completeDescription, completeAnimationGif = props.completeAnimationGif, buttonCompleteText = props.buttonCompleteText, type = props.type, onCompletePush = props.onCompletePush;
    var _a = React.useState(false), showPopup = _a[0], setPopup = _a[1];
    var _b = React.useState(999), compareTimeStamps = _b[0], setCmpareTimeStamps = _b[1];
    var _c = React.useState(0), timers = _c[0], setTimers = _c[1];
    var _d = React.useState(false), popupCongratsMeesage = _d[0], setPopupContent = _d[1];
    var _e = React.useState({
        inProgress: (pledgeLastClicked === null && doneDays != null && doneDays === 0) ||
            Boolean(doneDays != undefined && doneDays > 0),
        completed: completed != undefined && completed,
        daysCompleted: doneDays != undefined ? doneDays : 0,
        canComplete: false,
    }), challengeStatus = _e[0], setChallengeStatus = _e[1];
    var waterSaving = _.get(saving, "water", 0);
    var actionProps = {};
    var completedCheck = maxDays != undefined &&
        challengeStatus.daysCompleted != undefined &&
        challengeStatus.daysCompleted === maxDays - 1;
    var isMobileLandScape = window.innerHeight < 400;
    React.useEffect(function () {
        if (!timers || challengeStatus.inProgress) {
            checkChallengeStatus();
        }
        return function () { return clearInterval(timers); };
    }, []);
    React.useEffect(function () {
        if (ctaOpenPopup) {
            setPopup(true);
        }
    }, [ctaOpenPopup]);
    var checkChallengeStatus = function () {
        if (pledgeLastClicked) {
            var taskEnd_1 = date_fns_1.add(new Date(pledgeLastClicked), {
                seconds: pledgeTimePeriod,
            });
            if (date_fns_1.compareAsc(new Date(), taskEnd_1) != 1) {
                var timers_1 = setInterval(function () {
                    setCmpareTimeStamps(date_fns_1.compareAsc(new Date(), taskEnd_1)), 6000;
                });
                setTimers(timers_1);
            }
        }
    };
    var completeChallenge = function () {
        if (challengeStatus.daysCompleted != undefined && onDefaultClick) {
            var dayCount = challengeStatus.daysCompleted + 1;
            setChallengeStatus(__assign(__assign({}, challengeStatus), { completed: completedCheck, daysCompleted: dayCount }));
            onDefaultClick();
            onCompletePush();
            return setPopup(!showPopup);
        }
    };
    var startChallenge = function () {
        if (internalType === "confirmation" && onDefaultClick) {
            onDefaultClick();
            return setPopup(!showPopup);
        }
        // if final day of challenge show popup congrats
        if (maxDays && challengeStatus.daysCompleted === maxDays - 1) {
            setChallengeStatus(__assign(__assign({}, challengeStatus), { canComplete: true }));
            setPopupContent(true);
            return setPopup(!showPopup);
        }
        // Created a new date object after adding the pledgeTimePeriod
        // new date will be the pledgeLastClicked
        var taskEnd = date_fns_1.add(new Date(), {
            seconds: pledgeTimePeriod,
        });
        // returns a interval function to check every minute if the current date/time has passed or equal to the taskend date
        // Compare the two dates and return 1 if the first date is after the second, -1 if the first date is before the second or 0 if dates are equal.
        var timers = setInterval(function () {
            setCmpareTimeStamps(date_fns_1.compareAsc(new Date(), taskEnd)), 6000;
        });
        // Increase the day count here
        if (challengeStatus.daysCompleted != undefined) {
            var dayCount = challengeStatus.daysCompleted + 1;
            setChallengeStatus(__assign(__assign({}, challengeStatus), { completed: completedCheck, daysCompleted: dayCount }));
        }
        if (challengeStatus.daysCompleted != undefined &&
            challengeStatus.daysCompleted >= 0) {
            // send update
            onDefaultClick && onDefaultClick();
        }
        setTimers(timers);
    };
    if (timers && compareTimeStamps === 1) {
        // challenge compelte
        // reset all
        setCmpareTimeStamps(999);
        clearInterval(timers);
    }
    if (pushToHistory) {
        actionProps.onClick = function () {
            pushToHistory(buttonPath);
        };
    }
    else if (onDefaultClick) {
        actionProps.onClick = function () {
            // final checkbox updated by onDefaultClick from popup
            if (completedCheck && challengeStatus.canComplete) {
                return completeChallenge();
            }
            if (!challengeStatus.inProgress && internalType !== "direct-redirect") {
                setChallengeStatus(__assign(__assign({}, challengeStatus), { inProgress: true }));
            }
            onDefaultClick();
            setPopup(!showPopup);
        };
    }
    else if (buttonPath) {
        actionProps.href = buttonPath;
    }
    var popupProps = {};
    if (isPopup) {
        popupProps.onClick = function () {
            setPopup(!showPopup);
        };
    }
    else if (onArrowClick) {
        popupProps.onClick = function () {
            onArrowClick();
        };
    }
    var progressText = function () {
        if (internalType === "confirmation") {
            return null;
        }
        if (challengeStatus.daysCompleted === 0) {
            if (textKey && textKey.tick_start) {
                return textKey.tick_start;
            }
            return "Tick to start";
        }
        if (compareTimeStamps == -1) {
            if (textKey && textKey.back_tomorrow) {
                return textKey.back_tomorrow;
            }
            return "Come back tomorrow";
        }
        if (compareTimeStamps === 999 &&
            maxDays != undefined &&
            challengeStatus.daysCompleted === maxDays - 1 &&
            !challengeStatus.completed) {
            if (textKey && textKey.tick_to_complete) {
                return textKey.tick_to_complete;
            }
            return "Tick to complete";
        }
        if (compareTimeStamps === 999 &&
            maxDays != undefined &&
            challengeStatus.daysCompleted != maxDays - 1) {
            if (textKey && textKey.keep_up) {
                return textKey.keep_up;
            }
            return "Keep up the good work";
        }
        if (compareTimeStamps === 999 &&
            challengeStatus.daysCompleted === maxDays &&
            challengeStatus.completed) {
            if (textKey && textKey.complete) {
                return textKey.complete;
            }
            return "Easy win complete. Pick another";
        }
        return null;
    };
    var renderChecks = function () {
        var checks = new Array(maxDays);
        var taskText = (React.createElement(Task_style_1.default.TaskText, { style: {} },
            React.createElement("b", null,
                challengeStatus.daysCompleted,
                "/",
                maxDays,
                " ",
                progressText(),
                " ")));
        return (React.createElement(Task_style_1.default.Check, null,
            React.createElement(Task_style_1.default.CheckWrap, null, !completed &&
                _.map(checks, function (el, index) { return (React.createElement("div", { "data-test": "check-" + (index + 1), key: index },
                    React.createElement(Checkbox_1.default, { theme: "rounded", name: "checkbox", boxSize: 24, id: "" + index, checked: !!(challengeStatus.daysCompleted &&
                            challengeStatus.daysCompleted > index), disabled: compareTimeStamps === -1 ||
                            challengeStatus.daysCompleted === maxDays, onChange: function () { return startChallenge(); } }))); })),
            taskText));
    };
    var renderPopupContent = function () {
        // horizontal mobile image
        var mobileLandScapeImage = (React.createElement(Icon_1.default, { style: {
                position: "absolute",
                zIndex: -1,
                opacity: 0.2,
                height: "100%",
                width: "100%",
                padding: 6,
            }, size: 100, icon: icon }));
        if (isBonus && children) {
            return children;
        }
        if (!isBonus && completedCheck && popupCongratsMeesage) {
            var title_1 = function () {
                if (coins != undefined && coins > 0 && waterSaving > 0) {
                    if (textKey && textKey.save_earn) {
                        return textKey.save_earn;
                    }
                    return "You’ve saved and earned";
                }
                if (waterSaving === 0 && coins != undefined && coins > 0) {
                    if (textKey && textKey.earn) {
                        return textKey.earn;
                    }
                    return "You've earned";
                }
                if (coins === undefined || (coins === 0 && waterSaving > 0)) {
                    if (textKey && textKey.saved) {
                        return textKey.saved;
                    }
                    return "You've saved";
                }
                return null;
            };
            var completedChallenge = (React.createElement(React.Fragment, null,
                isMobileLandScape ? (mobileLandScapeImage) : (React.createElement("img", { src: completeAnimationGif, alt: "Congratulation" })),
                React.createElement(Task_style_1.default.PopupTitle, null, textKey && textKey.congrats
                    ? textKey.congrats
                    : "Congratulations!"),
                waterSaving || coins ? (React.createElement(Task_style_1.default.Description, null, title_1())) : null,
                React.createElement(Task_style_1.default.Description, null, completeDescription),
                waterSaving || coins ? (React.createElement(React.Fragment, null, waterSaving > 0 || (coins !== undefined && coins > 0) ? (React.createElement(Task_style_1.default.Savings, null,
                    waterSaving > 0 && (React.createElement(Task_style_1.default.SavingItem, null,
                        React.createElement(Task_style_1.default.IconWrap, null,
                            React.createElement(Icon_1.default, { size: 20, icon: "droplet" })),
                        React.createElement("div", null,
                            React.createElement("b", null,
                                waterSaving,
                                " ",
                                textKey && textKey.litres
                                    ? textKey.litres
                                    : "litres",
                                " ")))),
                    coins !== undefined && coins > 0 && (React.createElement(Task_style_1.default.SavingItem, { style: {
                            marginRight: 0,
                        } },
                        React.createElement(Task_style_1.default.IconWrap, null,
                            React.createElement(Icon_1.default, { size: 20, icon: "coins" })),
                        React.createElement("div", null,
                            React.createElement("b", null,
                                coins,
                                " ",
                                textKey && textKey.coins ? textKey.coins : "coins",
                                " ")))))) : null)) : null,
                React.createElement(Task_style_1.default.CtaWrap, { buttonBackground: buttonBackground, buttonActionBackground: buttonActionBackground },
                    React.createElement(Button_1.default, __assign({ full: true }, actionProps), buttonCompleteText))));
            return completedChallenge;
        }
        if (!isBonus &&
            (challengeStatus.inProgress || !challengeStatus.inProgress)) {
            var challengeInfo = (React.createElement(React.Fragment, null,
                isMobileLandScape ? (mobileLandScapeImage) : (React.createElement(Icon_1.default, { size: 100, icon: icon, style: {
                        marginBottom: "8px",
                    } })),
                React.createElement(Task_style_1.default.PopupTitle, null, title),
                React.createElement(Task_style_1.default.Description, null, description),
                maxDays || (coins && coins > 0) ? (React.createElement(Task_style_1.default.Savings, null,
                    maxDays ? (React.createElement(Task_style_1.default.SavingItem, null,
                        React.createElement(Task_style_1.default.IconWrap, null,
                            React.createElement(Icon_1.default, { size: 24, icon: "tree" })),
                        React.createElement("div", null,
                            React.createElement("b", null,
                                maxDays,
                                " ",
                                textKey && textKey.xDay
                                    ? textKey.xDay
                                    : "x day easy win",
                                " ")))) : null,
                    coins && coins > 0 ? (React.createElement(Task_style_1.default.SavingItem, null,
                        React.createElement(Task_style_1.default.IconWrap, null,
                            React.createElement(Icon_1.default, { size: 24, icon: "coins" })),
                        React.createElement("div", null,
                            React.createElement("b", null,
                                coins,
                                " ",
                                textKey && textKey.xCoins ? textKey.xCoins : "x coins",
                                " ")))) : null)) : null,
                waterSaving ? (React.createElement(Task_style_1.default.Savings, null,
                    React.createElement(Task_style_1.default.SavingItem, null,
                        React.createElement(Task_style_1.default.IconWrap, null,
                            React.createElement(Icon_1.default, { size: 24, icon: "droplet" })),
                        React.createElement("div", null,
                            React.createElement("b", null,
                                waterSaving,
                                " ",
                                textKey && textKey.xLitres ? textKey.xLitres : "x litres",
                                " "))))) : null,
                React.createElement(Task_style_1.default.CtaWrap, { buttonBackground: buttonBackground, buttonActionBackground: buttonActionBackground }, challengeStatus.inProgress ? (React.createElement(Button_1.default, { full: true, onClick: function () { return setPopup(!showPopup); } }, textKey && textKey.go_back ? textKey.go_back : "GO BACK")) : (React.createElement(Button_1.default, __assign({ full: true }, actionProps), buttonText)))));
            return challengeInfo;
        }
        return null;
    };
    var tasksFinished = completed != undefined
        ? completed
        : maxDays &&
            challengeStatus.daysCompleted &&
            maxDays === challengeStatus.daysCompleted;
    var hideClose = Boolean(maxDays != undefined &&
        challengeStatus.daysCompleted === maxDays - 1 &&
        popupCongratsMeesage);
    var handleCtaPopupClose = function () {
        if (closeCtaPopup) {
            closeCtaPopup("");
            setPopup(!showPopup);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Task_style_1.default.Wrap, { isDesktop: isDesktop, completed: tasksFinished, id: id, inProgress: challengeStatus.inProgress, internalType: internalType },
            React.createElement(Popup_1.default, { open: showPopup, handleClick: ctaOpenPopup ? handleCtaPopupClose : setPopup, hideCloseButton: closeButton || hideClose, isDesktop: isDesktop }, renderPopupContent()),
            React.createElement(Task_style_1.default.Loading, { className: loading ? "show" : null },
                React.createElement(Loader_1.default, { type: "dots", color: "#25b3eb", size: 1, inline: true })),
            !tasksFinished && !challengeStatus.inProgress ? (React.createElement(ButtonClean_1.default, __assign({ style: { width: "100%", textAlign: "left", fontSize: "18px" } }, popupProps),
                React.createElement(Task_style_1.default.TextWrap, null,
                    React.createElement(Task_style_1.default.Icon, null,
                        React.createElement(Icon_1.default, { size: 40, icon: icon })),
                    React.createElement(Task_style_1.default.Title, { style: { fontSize: isDesktop ? "18px" : "14px" } }, title),
                    React.createElement(Task_style_1.default.ArrowWrap, { style: {
                            backgroundColor: type && type === "externalLink" ? "#25b3eb" : "#98b235",
                        } },
                        React.createElement(Icon_1.default, { size: 30, icon: "chevronRight", colorPrimary: "#ffffff" }))))) : (React.createElement(Task_style_1.default.TextWrap, null,
                React.createElement(Task_style_1.default.Icon, null,
                    React.createElement(Icon_1.default, { size: 40, icon: icon })),
                React.createElement(Task_style_1.default.ContentWrap, null,
                    React.createElement(Task_style_1.default.Title, { style: { fontSize: isDesktop ? "18px" : "14px" } }, title),
                    challengeStatus.inProgress &&
                        !challengeStatus.completed &&
                        internalType !== "confirmation" &&
                        internalType !== "direct-redirect"
                        ? renderChecks()
                        : null),
                !challengeStatus.completed && (React.createElement(Task_style_1.default.ArrowWrap, { style: {
                        backgroundColor: type && type === "externalLink" ? "#25b3eb" : "#98b235",
                    }, onClick: function () {
                        setPopupContent(false), setPopup(true);
                    } },
                    React.createElement(Icon_1.default, { size: 30, icon: "chevronRight", colorPrimary: "#ffffff" }))))))));
};
exports.default = exports.Task;
//# sourceMappingURL=Task.js.map